<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let name = '';
  export let companyName = '';
  export let email = '';
  export let phone = '';

  const canSubmit = () => {
    return Boolean(name && email) || false;
  }

  const onInput = (e) => {
    dispatch('input', {
      canSubmit: canSubmit(),
      state: {
        name: name,
        companyName: companyName,
        email: email,
        phone: phone,
      }
    });
  }
</script>

<style>
  .row {
    margin-top: 1vw;
  }

  .row > .form-control:not(:last-child) {
    margin-right: 1vw;
  }
</style>

<main>
  <div class="row row-between">
    <div class="form-control">
      <label for="name">Your Name</label>
      <input
        id="name"
        type="text"
        placeholder="e.g John Doe"
        bind:value={name}
        on:input={onInput}
        required>
    </div>
  </div>
  <div class="row row-between">
    <div class="form-control">
      <label for="company-name">Company</label>
      <input
        id="company-name"
        type="text"
        placeholder="e.g Curbza"
        bind:value={companyName}
        on:input={onInput}>
    </div>
  </div>
  <div class="row row-between">
    <div class="form-control">
      <label for="email">Your Email</label>
      <input
        id="email"
        type="text"
        placeholder="e.g me@example.come"
        bind:value={email}
        on:input={onInput}
        required>
    </div>
  </div>
  <div class="row row-between">
    <div class="form-control">
      <label for="phone">Phone</label>
      <input
        id="phone"
        type="text"
        placeholder="e.g 902-000-0000"
        bind:value={phone}
        on:input={onInput}>
    </div>
  </div>
</main>